import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ListField from 'views/ListField.js';

const DatePickerDropdownField = ({ onChange, value }) => {

    const [day, setDay] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);

    const onComponentChange = (key, item) => {

        // declare values for components
        let d = key === 'day' ? item.id : day;
        let m = key === 'month' ? item.id : month;
        let y = key === 'year' ? item.id : year;

        // update local state values
        setDay(d);
        setMonth(m);
        setYear(y);

        // construct date and notify subscribers of date change
        if(d && m && y) {
            let date = moment(`${y}-${m}-${d}`, 'YYYY-MMMM-DD');
            if(typeof(onChange) === 'function') {
                onChange(date);
            }
        }
    }

    const onUpdateValueComponents = () => {
        if(value) {
            let date = moment(value);
            setDay(date.format('D'));
            setMonth(date.format('MMMM'));
            setYear(date.format('YYYY')); 
        }
    }

    const getDayItems = () => {
        let target = month && year ? moment(`${year}-${month}-01`, 'YYYY-MMMM-DD') : moment();
        return [...Array(target.daysInMonth() || 0)].map((_, index) => ({
            id: index + 1,
            title: index + 1
        }));
    }

    const getMonthItems = () => {
        return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(title => ({
            id: title,
            title: title
        }));
    }

    const getYearItems = () => {
        let year = parseInt(moment().format('YYYY'));
        return [...Array(100)].map((_, index) => ({
            id: year - index,
            title: year - index
        }));
    }

    useEffect(() => {
        onUpdateValueComponents();
    }, [value]);

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            height: 35,
            width: '100%'
        }}>
            <ListField
            items={getMonthItems()}
            onChange={onComponentChange.bind(this, 'month')}
            placeholder={'Month'}
            style={{
                marginRight: 8
            }}
            value={month} />

            <ListField
            items={getDayItems()}
            onChange={onComponentChange.bind(this, 'day')}
            placeholder={'Day'}
            value={day} />

            <ListField
            items={getYearItems()}
            onChange={onComponentChange.bind(this, 'year')}
            placeholder={'Year'}
            style={{
                marginLeft: 8
            }}
            value={year} />
        </div>
    )
}
export default DatePickerDropdownField;
